@switch (mode) {
  @case ('card') {
    <div class="file-page-scope file-page-scope--card">
      <div class="scope-row">
        <mat-icon class="scope-icon" aria-hidden="true">description</mat-icon>
        <span class="scope-label">File:</span>
        @if (view.links.fileDeepLink) {
          <a
            class="scope-link scope-value"
            [routerLink]="view.links.fileDeepLink"
            [matTooltip]="view.links.fileTooltip"
            [attr.aria-label]="view.fileAriaLabel"
          >
            {{ view.fileText }}
          </a>
        } @else {
          <span class="scope-value">{{ view.fileText || '—' }}</span>
        }
      </div>

      <div class="scope-row">
        <mat-icon class="scope-icon" aria-hidden="true">collections_bookmark</mat-icon>
        <span class="scope-label">{{ view.pageLabel }}:</span>
        @if (view.links.pageDeepLink) {
          <a
            class="scope-link scope-value"
            [routerLink]="view.links.pageDeepLink"
            [matTooltip]="view.pageTooltip"
            [attr.aria-label]="view.pageAriaLabel"
          >
            {{ view.pageText }}
          </a>
        } @else {
          <span class="scope-value">{{ view.pageText || '—' }}</span>
        }
      </div>
    </div>
  }
  @case ('inline') {
    <span class="file-page-scope file-page-scope--inline">
      <mat-icon class="inline-icon" aria-hidden="true">description</mat-icon>
      <span>File:</span>
      @if (view.links.fileDeepLink) {
        <a
          class="scope-link"
          [routerLink]="view.links.fileDeepLink"
          [matTooltip]="view.links.fileTooltip"
          [attr.aria-label]="view.fileAriaLabel"
        >
          {{ view.fileText }}
        </a>
      } @else {
        <span>{{ view.fileText || '—' }}</span>
      }
      <span class="inline-pages">({{ view.pageLabel }}:</span>
      @if (view.links.pageDeepLink) {
        <a
          class="scope-link"
          [routerLink]="view.links.pageDeepLink"
          [matTooltip]="view.pageTooltip"
          [attr.aria-label]="view.pageAriaLabel"
        >
          {{ view.pageText }}
        </a>
      } @else {
        <span>{{ view.pageText || '—' }}</span>
      }
      <span>)</span>
    </span>
  }
  @default {
    <span class="file-page-scope file-page-scope--link scope-title">
      @if (view.links.fileDeepLink) {
        <a
          class="scope-link"
          [routerLink]="view.links.fileDeepLink"
          [matTooltip]="view.links.fileTooltip"
          [attr.aria-label]="view.fileAriaLabel"
        >
          File {{ view.fileText }}
        </a>
      } @else {
        <span>File {{ view.fileText || '—' }}</span>
      }
      <span class="scope-separator"> › </span>
      @if (view.links.pageDeepLink) {
        <a
          class="scope-link"
          [routerLink]="view.links.pageDeepLink"
          [matTooltip]="view.pageTooltip"
          [attr.aria-label]="view.pageAriaLabel"
        >
          {{ view.pageLabel }} {{ view.pageText }}
        </a>
      } @else {
        <span>{{ view.pageLabel }} {{ view.pageText || '—' }}</span>
      }
      @if (pageTitle) {
        <span class="scope-page-title"> — {{ pageTitle }}</span>
      }
    </span>
  }
}
